export default {
  badge: 'Індикатор',
  open: 'Відкрити',
  close: 'Закрити',
  dismiss: 'Відхилити',
  confirmEdit: {
    ok: 'ОК',
    cancel: 'Скасувати',
  },
  dataIterator: {
    noResultsText: 'В результаті пошуку нічого не знайдено',
    loadingText: 'Завантаження...',
  },
  dataTable: {
    itemsPerPageText: 'Рядків на сторінці:',
    ariaLabel: {
      sortDescending: 'Відсортовано за спаданням.',
      sortAscending: 'Відсортовано за зростанням.',
      sortNone: 'Не відсортовано.',
      activateNone: 'Активуйте, щоб прибрати сортування.',
      activateDescending: 'Активуйте, щоб відсортувати за спаданням.',
      activateAscending: 'Активуйте, щоб відсортувати за зростанням.',
      selectRow: 'Вибрати рядок',
      selectAll: 'Вибрати всі',
      selectGroup: 'Вибрати групу',
    },
    sortBy: 'Сортувати за',
  },
  dataFooter: {
    itemsPerPageText: 'Елементів на сторінці:',
    itemsPerPageAll: 'Всі',
    nextPage: 'Наступна сторінка',
    prevPage: 'Попередня сторінка',
    firstPage: 'Перша сторінка',
    lastPage: 'Остання сторінка',
    pageText: '{0}-{1} з {2}',
  },
  dateRangeInput: {
    divider: 'до',
  },
  monthPicker: {
    title: 'Виберіть місяць',
    itemsSelected: 'Вибрано {0}',
    header: 'Введіть місяць',
    range: {
      title: 'Введіть місяці',
    },
    ariaLabel: {
      previousYear: 'Попередній рік',
      nextYear: 'Наступний рік',
      selectYear: 'Виберіть рік',
      currentMonth: 'Поточний місяць, {0}',
    },
  },
  datePicker: {
    itemsSelected: 'Вибрано {0}',
    range: {
      title: 'Виберіть дати',
      header: 'Введіть дати',
    },
    title: 'Виберіть дату',
    header: 'Введіть дату',
    input: {
      placeholder: 'Введіть дату',
    },
    ariaLabel: {
      previousMonth: 'Попередній місяць',
      nextMonth: 'Наступний місяць',
      selectYear: 'Виберіть рік',
      previousYear: 'Попередній рік',
      nextYear: 'Наступний рік',
      selectMonth: 'Виберіть місяць',
      selectDate: '{0}',
      currentDate: 'Сьогодні, {0}',
    },
  },
  noDataText: 'Немає даних для відображення',
  carousel: {
    prev: 'Попередній слайд',
    next: 'Наступний слайд',
    ariaLabel: {
      delimiter: 'Слайд {0} з {1}',
    },
  },
  calendar: {
    moreEvents: 'Ще {0}',
    today: 'Сьогодні',
  },
  heatmap: {
    less: 'Менше',
    more: 'Більше',
  },
  input: {
    clear: 'Очистити {0}',
    prependAction: 'Дія перед полем {0}',
    appendAction: 'Дія після поля {0}',
    otp: 'Введіть код підтвердження',
  },
  fileInput: {
    counter: 'Файлів: {0}',
    counterSize: 'Файлів: {0} ({1} загалом)',
  },
  fileUpload: {
    title: 'Перетягніть файли сюди',
    divider: 'або',
    browse: 'Вибрати файли',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Виберіть час',
    hour: 'Година',
    minute: 'Хвилина',
    second: 'Секунда',
    notAllowed: 'Значення неприпустиме',
  },
  pagination: {
    ariaLabel: {
      root: 'Посторінкова навігація',
      next: 'Наступна сторінка',
      previous: 'Попередня сторінка',
      page: 'Перейти на сторінку {0}',
      currentPage: 'Сторінка {0}, поточна сторінка',
      first: 'Перша сторінка',
      last: 'Остання сторінка',
    },
  },
  stepper: {
    next: 'Далі',
    prev: 'Назад',
  },
  rating: {
    ariaLabel: {
      item: 'Оцінка {0} з {1}',
    },
  },
  loading: 'Завантаження...',
  infiniteScroll: {
    loadMore: 'Завантажити більше',
    empty: 'Немає більше даних',
  },
  rules: {
    required: 'Це поле є обов’язковим',
    email: 'Будь ласка, введіть коректну адресу електронної пошти',
    number: 'Це поле може містити лише цифри',
    integer: 'Це поле може містити лише цілі числа',
    capital: 'Це поле може містити лише великі літери',
    maxLength: 'Ви повинні ввести максимум {0} символів',
    minLength: 'Ви повинні ввести мінімум {0} символів',
    strictLength: 'Неправильна довжина значення',
    exclude: 'Символ {0} неприпустимий',
    notEmpty: 'Будь ласка, виберіть принаймні одне значення',
    pattern: 'Неправильний формат',
  },
  command: {
    search: 'Введіть команду або виконайте пошук...',
  },
  hotkey: {
    then: 'потім',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Стрілка вгору',
    downArrow: 'Стрілка вниз',
    leftArrow: 'Стрілка вліво',
    rightArrow: 'Стрілка вправо',
    backspace: 'Backspace',
    space: 'Пробіл',
    plus: 'плюс',
    shortcut: 'Комбінація клавіш: {0}',
    or: 'або',
  },
  video: {
    play: 'Відтворити',
    pause: 'Пауза',
    seek: 'Позиція відтворення',
    volume: 'Гучність',
    showVolume: 'Показати регулятор гучності',
    mute: 'Вимкнути звук',
    unmute: 'Увімкнути звук',
    enterFullscreen: 'На весь екран',
    exitFullscreen: 'Вийти з повноекранного режиму',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Вибрати колір піпеткою',
      hueSlider: 'Відтінок',
      alphaSlider: 'Прозорість',
      redInput: 'Значення червоного',
      greenInput: 'Значення зеленого',
      blueInput: 'Значення синього',
      alphaInput: 'Значення прозорості',
      hueInput: 'Значення відтінку',
      saturationInput: 'Значення насиченості',
      lightnessInput: 'Значення світлості',
      hexInput: 'Значення HEX',
      hexaInput: 'Значення HEX із прозорістю',
      changeFormat: 'Змінити формат кольору',
    },
  },
}
